import React, { ChangeEvent } from "react";
import "./form.scss";
type Props = {
  disabled: boolean;
  name: string;
  type: string;
  value: any;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  maxLength: number;
  placeholder: string;
  validator: any;
  label: string;
  mandatory: boolean;
  hideLabel: boolean;
  validatoryType: string;
  checked: boolean;
};

export default function Checkbox({
  disabled,
  name,
  type,
  value,
  onChange,
  maxLength,
  placeholder,
  validator,
  label,
  mandatory,
  hideLabel,
  validatoryType,
  checked,
}: Props) {

  return (
    <div
      className={`form-checkbox-control${
        validator ? " has-error" : ""
      }${disabled ? " is-disabled" : ""}`}
    >
      <label className="form-checkbox-control__label">
        <input
          className="form-checkbox-control__input"
          disabled={disabled}
          name={name}
          type={type}
          value={value}
          checked={checked}
          onChange={(e) => onChange(e)}
          aria-label={hideLabel ? label : undefined}
      />
        {!hideLabel && (
          <span className="form-checkbox-control__text">
            {label}
            {mandatory && (
              <span className="form-checkbox-control__required"> *</span>
            )}
          </span>
        )}
      </label>
      {validator && (
        <p className="form-checkbox-control__error">
          {validator.current.message(
            label,
            value,
            validatoryType ? validatoryType : "required"
          )}
        </p>
      )}
    </div>
  );
}
